/*
  Pinnacle Garage USA - fills in factory wheel specs for vehicles in PG_VEHICLES (assets/pg-fitment-data.js) that
  only had bolt pattern / hub info, so the Wheel & Tire Size Guide lists every vehicle the Shop by Vehicle search
  lists, and wheel matching works for them everywhere.
  Loaded (deferred) after pg-fitment-data.js on every page via sections/pg-fitment-fill.liquid in the footer group.
  Spec format = factorySpec in pg-fitment-data.js:
    [[bolt patterns], frontWidth, frontOffset, rearWidth, rearOffset, minDiameter, maxDiameter, factoryDiameter, "factory setup"]
  Ranges use the same estimate as the other src "est" rows: bolt-on = factory outer lip +17.65mm / inner +5.95mm,
  width -1 / +1; with mods = outer +38.35mm / inner +11.95mm, width -1 / +2.
  Key = "Make|Model|yearFrom" (exactly as in pg-fitment-data.js).
*/
(function () {
  var V = window.PG_VEHICLES;
  if (!V || V._pgFilled) return;
  var ADD = {
    "Audi|A6 / S6 (C8)|2019": [["5x112"], 8, 39, 8, 39, 18, 21, 18],
    "Audi|A7 / S7 / RS7|2012": [["5x112"], 8.5, 43, 8.5, 43, 18, 21, 18],
    "Audi|Q3|2015": [["5x112"], 7, 43, 7, 43, 17, 20, 18],
    "Audi|Q7 / SQ7|2007": [["5x112", "5x130"], 8.5, 28, 8.5, 28, 19, 22, 19],
    "Audi|Q8 / SQ8 / RS Q8|2019": [["5x112"], 9.5, 21, 9.5, 21, 20, 23, 21],
    "BMW|M5 (F10)|2012": [["5x120"], 9, 32, 10, 34, 19, 20, 19],
    "BMW|Z4 (E85/E86)|2003": [["5x120"], 8, 47, 8.5, 50, 16, 19, 17],
    "Cadillac|ATS|2013": [["5x120"], 8, 40, 8, 40, 17, 20, 17],
    "Cadillac|CTS|2008": [["5x120", "5x115"], 8.5, 40, 8.5, 40, 17, 20, 18],
    "Cadillac|CT4|2020": [["5x120"], 8, 40, 8, 40, 18, 20, 18],
    "Cadillac|CT5|2020": [["5x120"], 8.5, 40, 8.5, 40, 18, 20, 18],
    "Chevrolet|Cobalt|2005": [["5x110"], 6, 44, 6, 44, 15, 18, 15],
    "Chevrolet|Cruze|2011": [["5x105"], 6.5, 39, 6.5, 39, 15, 19, 16],
    "Chevrolet|Malibu|2013": [["5x115"], 7.5, 40, 7.5, 40, 16, 20, 17],
    "Dodge|Durango|2011": [["5x127"], 8, 34, 8, 34, 18, 22, 18],
    "Honda|HR-V|2016": [["5x114.3"], 7, 55, 7, 55, 16, 19, 17],
    "Honda|HR-V|2021": [["5x114.3"], 7, 55, 7, 55, 16, 19, 17],
    "Honda|HR-V|2023": [["5x114.3"], 7, 50, 7, 50, 17, 20, 17],
    "Hyundai|Veloster|2012": [["5x114.3"], 7, 48, 7, 48, 16, 19, 17],
    "Infiniti|M / Q70|2006": [["5x114.3"], 8, 43, 8, 43, 18, 20, 18],
    "Jeep|Grand Cherokee|2011": [["5x127"], 8, 56, 8, 56, 17, 22, 18],
    "Kia|Forte|2014": [["5x114.3"], 6.5, 46, 6.5, 46, 15, 19, 16],
    "Lexus|CT|2011": [["5x100"], 7, 45, 7, 45, 16, 18, 17],
    "Lexus|ES|2006": [["5x114.3"], 6.5, 45, 6.5, 45, 16, 18, 16],
    "Lexus|RX|2010": [["5x114.3"], 7.5, 35, 7.5, 35, 18, 20, 18],
    "Lexus|RX|2016": [["5x114.3"], 8, 30, 8, 30, 18, 21, 18],
    "Lexus|RX|2023": [["5x114.3"], 8, 30, 8, 30, 19, 22, 19],
    "Mercedes-Benz|A-Class|2019": [["5x112"], 7.5, 49, 7.5, 49, 17, 20, 18],
    "Mercedes-Benz|CLA|2014": [["5x112"], 7.5, 52, 7.5, 52, 17, 19, 18],
    "Mercedes-Benz|CLA|2020": [["5x112"], 7.5, 49, 7.5, 49, 18, 20, 18],
    "Mercedes-Benz|CLK|1998": [["5x112"], 7.5, 37, 8.5, 30, 16, 19, 17],
    "Mercedes-Benz|GL / GLS|2007": [["5x112"], 8.5, 56, 8.5, 56, 19, 22, 19],
    "Mercedes-Benz|GLA|2015": [["5x112"], 7.5, 49, 7.5, 49, 18, 20, 18],
    "Mercedes-Benz|GLC|2016": [["5x112"], 7.5, 44, 7.5, 44, 18, 21, 19],
    "Mercedes-Benz|GLE|2016": [["5x112"], 8, 38, 8, 38, 19, 22, 19],
    "Mercedes-Benz|GLK|2010": [["5x112"], 8, 38, 8, 38, 18, 20, 19],
    "Mercedes-Benz|S-Class (W223)|2021": [["5x112"], 8.5, 38, 8.5, 38, 19, 21, 19],
    "Mercedes-Benz|SLK|2005": [["5x112"], 7.5, 37, 8.5, 30, 17, 19, 17],
    "Mitsubishi|Lancer|2008": [["5x114.3"], 6.5, 46, 6.5, 46, 16, 18, 16],
    "Nissan|Sentra|2013": [["5x114.3"], 6.5, 40, 6.5, 40, 15, 19, 16],
    "Ram|1500|2009": [["5x139.7"], 8, 19, 8, 19, 17, 22, 18],
    "Subaru|Forester|2009": [["5x100", "5x114.3"], 7, 48, 7, 48, 16, 19, 17],
    "Subaru|Impreza|2012": [["5x100"], 6.5, 48, 6.5, 48, 16, 18, 16],
    "Toyota|4Runner|1996": [["6x139.7"], 7, 15, 7, 15, 15, 18, 16],
    "Toyota|4Runner|2003": [["6x139.7"], 7.5, 30, 7.5, 30, 16, 20, 17],
    "Toyota|4Runner|2025": [["6x139.7"], 7.5, 50, 7.5, 50, 17, 20, 18],
    "Toyota|Corolla|2009": [["5x100"], 6.5, 45, 6.5, 45, 15, 18, 16],
    "Toyota|FJ Cruiser|2007": [["6x139.7"], 7.5, 15, 7.5, 15, 16, 20, 17],
    "Toyota|Highlander|2001": [["5x114.3"], 7.5, 35, 7.5, 35, 17, 20, 18],
    "Toyota|Prius|2016": [["5x100"], 6.5, 40, 6.5, 40, 15, 18, 15],
    "Toyota|RAV4|2013": [["5x114.3"], 7, 35, 7, 35, 17, 20, 17],
    "Toyota|Sienna|2011": [["5x114.3"], 7, 45, 7, 45, 17, 20, 17],
    "Toyota|Tundra|2007": [["5x150"], 8, 60, 8, 60, 18, 22, 18],
    "Volkswagen|CC|2009": [["5x112"], 8, 41, 8, 41, 17, 19, 17],
    "Volkswagen|Passat|2012": [["5x112"], 7, 40, 7, 40, 16, 19, 17]
  };
  function r1(x) { return Math.round(x * 10 + 1e-6) / 10; }
  function env(s, w, et, dOut, dIn, dW) { var o = w * 12.7 - et, i = w * 12.7 + et; return [s[5], s[6], w - 1, w + dW, r1(o + dOut), r1(i + dIn)]; }
  function sg(n) { return (n >= 0 ? '+' : '') + n; }
  V.forEach(function (row) {
    var s = ADD[row[0] + '|' + row[1] + '|' + row[2]];
    if (!s) return;
    if (!row[5]) row[5] = s.slice(0, 8);
    if (!row[6]) {
      var E = [env(s, s[1], s[2], 17.65, 5.95, 1), env(s, s[3], s[4], 17.65, 5.95, 1), env(s, s[1], s[2], 38.35, 11.95, 2), env(s, s[3], s[4], 38.35, 11.95, 2)], e = {};
      s[0].forEach(function (p) { e[p] = E; });
      var stag = s[1] !== s[3] || s[2] !== s[4];
      row[6] = { e: e, o: [stag ? 'F ' + s[7] + 'x' + s[1] + ' ' + sg(s[2]) + ' \u00b7 R ' + s[7] + 'x' + s[3] + ' ' + sg(s[4]) : s[7] + 'x' + s[1] + ' ' + sg(s[2])], src: 'est' };
    } else if (row[6].o && !row[6].o.length) {
      row[6].o = [s[7] + 'x' + s[1] + ' ' + sg(s[2])];
    }
  });
  V._pgFilled = true;
})();
